module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/workers/worker.0938c147fdcac90a930a.js");
};